import React, { useEffect } from "react";
import { Link, useLocation } from "react-router";
import { Popover } from "@ark-ui/react";
import { useTranslation } from "react-i18next";
import { EnvelopeIcon, XMarkIcon } from "@heroicons/react/24/outline";

import { useUserStore } from "../../../store/userStore";
import { useCommonStore } from "../../../store/commonStore";
import Notifications from "../home/Notifications";
import Button from "../../atoms/Button";
import { useEvent } from "../../../hooks/useEvent";

function InboxNotifications({ mobileView = false }: { mobileView?: boolean }) {
  const { t } = useTranslation(["inbox"]);
  const location = useLocation();
  const { markNotificationsRead } = useEvent();
  const displayInbox = useCommonStore((state) => state.displayInbox);
  const setDisplayInbox = useCommonStore((state) => state.setDisplayInbox);
  const setDisplayNotifications = useCommonStore(
    (state) => state.setDisplayNotifications
  );

  useEffect(() => {
    setDisplayInbox(false);
  }, [location.pathname]);

  const user = useUserStore((state) => state.user);

  return (
    <Popover.Root open={displayInbox}>
      <Popover.Trigger
        className="bg-surface-raised hover:bg-surface-base text-text-base p-2 rounded-full shadow-sm hover:shadow-md lg:text-lg flex shadow-md hover:shadow-lg rounded-xl p-[11px] relative hover:cursor-pointer"
        onClick={() => {
          markNotificationsRead("messages");
          setDisplayInbox(!displayInbox);
          setDisplayNotifications(false);
        }}
        aria-label={"Open messages"}
      >
        <span>
          <EnvelopeIcon className="w-6 h-6" />{" "}
          {user.notifications &&
          user.notifications.filter(
            (notification: any) =>
              notification.type === "new-message" && notification.isRead === 0
          ).length > 0 ? (
            <span className="absolute top-1 right-1 text-text-inverted rounded-full text-xs bg-surface-primary w-5 h-5 flex items-center justify-center">
              {
                user.notifications.filter(
                  (notification) =>
                    notification.type === "new-message" &&
                    notification.isRead === 0
                ).length
              }
            </span>
          ) : (
            ""
          )}
        </span>
      </Popover.Trigger>
      <Popover.Positioner>
        <Popover.Content className="bg-surface-raised rounded-2xl p-3 text-text-base max-h-[80vh] overflow-y-auto z-50 shadow-xl min-w-0 max-w-sm">
          <div className="ml-auto flex justify-between mb-3 items-center">
            <Link
              to="/inbox"
              className="uppercase text-text-link hover:underline underline-offset-4"
              onClick={() => {
                console.log("setting display notifications to false");
              }}
            >
              {t(`inbox.viewInbox`)}
            </Link>
            {mobileView && (
              <Button
                onClick={() => setDisplayInbox(false)}
                style="tertiary"
                className="!px-3"
                aria-label="Close inbox"
              >
                <XMarkIcon className="w-6 h-6 text-text-base" />
              </Button>
            )}
          </div>
          <Notifications
            data={
              user.notifications &&
              user.notifications.filter(
                (notification: any) => notification.type === "new-message"
              )
            }
            type="messages"
          />
        </Popover.Content>
      </Popover.Positioner>
    </Popover.Root>
  );
}

export default InboxNotifications;
